
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.537 2.901a9.59 9.59 0 01-2.763.746 4.798 4.798 0 002.11-2.653c-.94.56-1.97.954-3.045 1.163A4.786 4.786 0 0016.333.636c-2.66 0-4.798 2.162-4.798 4.814 0 .373.045.745.119 1.103a13.624 13.624 0 01-9.895-5.037 4.788 4.788 0 00-.652 2.43 4.818 4.818 0 002.138 4.01 4.83 4.83 0 01-2.17-.613v.06a4.81 4.81 0 003.848 4.723 5.07 5.07 0 01-1.265.164c-.312 0-.607-.031-.905-.073a4.808 4.808 0 004.485 3.338 9.6 9.6 0 01-5.957 2.057c-.402 0-.773-.014-1.16-.06a13.559 13.559 0 007.37 2.16c8.825 0 13.654-7.332 13.654-13.695 0-.209 0-.417-.015-.627a10.35 10.35 0 002.407-2.488z","fill":"#fff"}})])
          )
        }
      }
    